import { render, staticRenderFns } from "./o-step-hyphens-text.vue?vue&type=template&id=709af498&"
import script from "./o-step-hyphens-text.vue?vue&type=script&lang=js&"
export * from "./o-step-hyphens-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports